/// <amd-module name="TFS/Admin/Views/ProfileSettings/ThemeView/ThemeTile/ThemeTile" />
import React = require("react");

import { css } from "VSS/Platform/Layout";
import { ClientTheme } from "VSS/Platform/Theming";
import { expandThemeableProperties } from "VSS/Core/Util/Theming";
import { FocusGroupContext } from "VSSUI/FocusGroup";
import { FocusZoneContext } from "VSSUI/FocusZone";
import { KeyCode } from "VSSUI/Util";
import { getTabIndex } from "VSSUI/Utilities/Focus";

interface ThemeTileProps {
    theme: ClientTheme;
    selected: boolean;
    onThemeSelected: (theme: ClientTheme) => void;
}

function sanitizeThemeId(id: string) {
    return id.replace(/\./g, "-");
}

export class ThemeTile extends React.Component<ThemeTileProps> {
    constructor(props: ThemeTileProps, context?: any) {
        super(props, context);
    }

    /**
     * @override
     */
    public render(): JSX.Element {
        const { onThemeSelected, selected, theme } = this.props;

        const headerBackground = expandThemeableProperties("var(--nav-header-background)", theme.data);
        const headerProductColor = expandThemeableProperties("var(--nav-header-product-color)", theme.data);
        const verticalNav = expandThemeableProperties("var(--nav-vertical-background-color)", theme.data);
        const backgroundColor = expandThemeableProperties("var(--background-color)", theme.data);
        const primaryText = expandThemeableProperties("var(--text-primary-color)", theme.data);
        const communication = expandThemeableProperties("rgba(var(--palette-primary), 1)", theme.data);

        return (
            <FocusGroupContext.Consumer>
                {focusGroupContext => (
                    <FocusZoneContext.Consumer>
                        {focusZoneContext => {
                            const id = `theme-${sanitizeThemeId(theme.id)}`;
                            return (
                                <div
                                    aria-label={theme.name}
                                    onClick={() => {
                                        onThemeSelected(theme);
                                    }}
                                    onFocus={() => focusGroupContext.onFocus(id)}
                                    onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
                                        const which = e.which;
                                        if (which === KeyCode.enter || which === KeyCode.space) {
                                            onThemeSelected(theme);
                                        }
                                    }}
                                    className={css("theme-tile-container", selected && "selected")}
                                    data-focuszone={focusZoneContext.focuszoneId}
                                    id={id}
                                    tabIndex={getTabIndex({ id: id }, focusGroupContext)}
                                    role="button"
                                >
                                    <div className="theme-tile">
                                        <div
                                            className="theme-tile-sections"
                                            style={{ backgroundColor: backgroundColor, borderColor: `rgba(${primaryText}, 0.3)` }}
                                        >
                                            <div
                                                className="theme-header"
                                                style={{ background: headerBackground, boxShadow: primaryText + " 0px 1px 0px", zIndex: 1 }}
                                            >
                                                <div className="theme-button" style={{ backgroundColor: headerProductColor }} />
                                            </div>
                                            <div className="theme-nav" style={{ backgroundColor: verticalNav }} />
                                            <div className="theme-background" style={{ backgroundColor: backgroundColor }}>
                                                <div className="theme-text long" style={{ backgroundColor: primaryText }} />
                                                <div className="theme-text" style={{ backgroundColor: primaryText }} />
                                                <div className="theme-text short" style={{ backgroundColor: primaryText }} />
                                                <div className="theme-text long" style={{ backgroundColor: primaryText }} />
                                                <div className="theme-button wide" style={{ backgroundColor: communication }} />
                                            </div>
                                        </div>
                                        <div className="theme-name">{theme.name}</div>
                                    </div>
                                </div>
                            );
                        }}
                    </FocusZoneContext.Consumer>
                )}
            </FocusGroupContext.Consumer>
        );
    }
}
